<template>
<div class="row q-col-gutter-lg q-mb-md">
  <div class="col-12 col-md-6">
    <common-input
        v-model="form.first_name"
        label="Voornaam"
        name="first_name"
        :error-message="$errorMessage('first_name')"
        :error="$hasError('first_name')"
        required
        autofocus
    />
  </div>
  <div class="col-12 col-md-6">
    <common-input
        v-model="form.last_name"
        label="Achternaam"
        name="last_name"
        :error-message="$errorMessage('last_name')"
        :error="$hasError('last_name')"
        required
    />
  </div>
  <div v-if="isCreate" class="col-12 q-pb-sm">
    <common-input
        v-model="form.email"
        label="E-mailadres"
        type="email"
        name="email"
        :error-message="$errorMessage('email')"
        :error="$hasError('email')"
    />
  </div>
</div>
<h3 v-if="isCreate" class="q-mt-lg q-mb-md">Rechten van de nieuwe gebruiker</h3>
<div class="heading-4">
  Rollen:
</div>
<div class="row q-mb-md">
  <option-group
      v-model="form.role_ids"
      :options="optionsArray"
      name="role_ids[]"
      color="primary"
      label="Rollen van de gebruiker"
      type="checkbox"
  />
</div>

<q-separator v-if="!isCreate" />
<div class="heading-4 q-my-md">
  Rechten per categorie:
</div>
<div v-for="category in categories" :key="category.id" class="row q-mb-md">
  <div class="col-12 col-sm-6 q-mt-sm">
    {{ category.title }}
  </div>
  <div class="col-12 col-sm-6">
    <common-select
        map-options
        v-model="form.categories[category.id]"
        :options="permissionTypes"
        :id="`category_${category.id}`"
        :for="`category_${category.id}`"
        :name="`categories[${category.id}][authority]`"
        label="Selecteer rechten" />
  </div>
</div>
</template>

<script>
import { permissionTypes } from '~HIOR/constants'

export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
    isCreate: {
      type: Boolean,
      default: false,
    },
    roles: {
      type: Array,
      default: () => [],
    },
    roleIds: {
      type: Array,
      default: () => [],
    },
    categories: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      form: {
        first_name: this.$old('first_name', this.user?.first_name),
        last_name: this.$old('last_name', this.user?.last_name),
        email: this.$old('email', this.user?.email),
        role_ids: [...this.roleIds],
        categories: this.user.categories.reduce((categories, category) => {
          return {
            ...categories,
            [category.id]: category.pivot.authority,
          }
        }, []),
      },
    }
  },
  computed: {
    optionsArray () {
      return this.roles.map((role) => {
        return {
          value: role.id,
          label: role.name,
        }
      })
    },
    permissionTypes () {
      return [
        { value: permissionTypes.AUTHORITY_NONE, label: 'Geen' },
        { value: permissionTypes.AUTHORITY_TESTER, label: 'Toetsen' },
        { value: permissionTypes.AUTHORITY_EDITOR, label: 'Aanmaken en bewerken' },
        { value: permissionTypes.AUTHORITY_EDITING_TESTER, label: 'Aanmaken, bewerken en toetsen' },
        { value: permissionTypes.AUTHORITY_PUBLISHER, label: 'Aanmaken, bewerken en publiceren' },
        { value: permissionTypes.AUTHORITY_MANAGER, label: 'Aanmaken, bewerken, publiceren en toetsen' },
      ]
    },
  },
}
</script>
